import React from "react"
import styles from "./audio.module.scss"

const Audio = props => {
  const { url, className = "" } = props
  if (url === undefined) {
    return <div className={className}>No Audio Available</div>
  }
  return (
    <div className={className}>
      <iframe className={styles.iframe} title="Podcast" src={url} frameBorder="0" scrolling="no" />
    </div>
  )
}

export default Audio
